/** i18n keys for unified listings upgrade actions (buttons + quota modal title). */
export const UNIFIED_LISTING_ACTION_TITLE_BY_SLUG = {
  'hot-listing': 'Apply Feature',
  'signature-listing': 'Upgrade to Elite',
  refresh: 'Boost to Top',
};

/** Short labels on unified listing action buttons (applicable + applied pill). */
export const UNIFIED_LISTING_ACTION_LABEL_BY_SLUG = {
  'signature-listing': 'unifiedBadgeElite',
  'elite-listing': 'unifiedBadgeElite',
  'hot-listing': 'unifiedActionFeature',
  feature: 'unifiedActionFeature',
  refresh: 'Boost to Top',
  'boost-to-top': 'Boost to Top',
};

export const getUnifiedListingActionTitleKey = (product) => {
  const slug = product?.slug;
  return slug ? UNIFIED_LISTING_ACTION_TITLE_BY_SLUG[slug] ?? null : null;
};

export const getUnifiedListingActionLabelKey = (slug) =>
  slug ? UNIFIED_LISTING_ACTION_LABEL_BY_SLUG[slug] ?? null : null;
